<template>
  <div class="content" v-if="show">
    <div class="d-flex justify-end">
      <div class="close-btn" @click="redirectToHome">&times;</div>
    </div>
    <div style="text-align: center">
      <h4 style="font-weight: 400 !important;color: #555555;font-size: 1.85rem">{{ $t('register.registration') }}</h4>
      <p class="text-weight-regular regist-txt pt-2 mb-6">
        {{ $t('register.registration.select') }}
      </p>
    </div>
    <div class="submit-container">
      <v-btn @click="continueEmailRegister" block class="btn-common mb-4" x-large :large="$vuetify.breakpoint.xsOnly">
        {{ $t('register.registration.withEmail') }}
      </v-btn>
      <v-btn @click="continueMaxWalletModal" block class="btn-yellow mb-4" x-large :large="$vuetify.breakpoint.xsOnly">
        <img class="btn-mxw-logo" :src="maxWalletLogo" alt="max-wallet" height="40px" />
        {{ $t('register.registration.withMaxWallet') }}
      </v-btn>
    </div>
    <div class="regist-txt">
      {{ $t('register.alreadyRegist') }}
      <router-link to="/login">
        {{ $t('actions.loginNow') }}
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChooseTypeRegister',
  components: {},
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    large: {
      type: Boolean,
      default: false
    },
    medium: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      walletBg: require('@/assets/images/home/max-wallet.png'),
      maxWalletLogo: require('@/assets/images/account/max-wallet.png')
    };
  },
  methods: {
    continueMaxWalletModal() {
      this.$emit('showMaxRegister');
    },
    continueEmailRegister() {
      this.$emit('showRegisterForm');
    },
    redirectToHome() {
      this.$emit('redirectToHome');
    }
  }
};
</script>

<style lang="stylus" scoped>
@import "../../regist.scoped.styl";
@import "../../../common.styl";
.mxw-wallet-benefit {
  background: #F5F5F8 0% 0% no-repeat padding-box;
  padding: 10px;
  margin-bottom: 15px;
}

.register-page {
  margin-top: 0px;
}

.mxw-wallet-benefit td {
  font-size: 14px;
}

.download-model {
  background: red;
  padding: 20px;
}

.bottom-section {
  background-color: #F5F5F8;
  margin: 10px -15px -15px -15px;
  min-height: 150px;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  padding: 20px;

  .img-step {
    max-width: 100px;
    width: 100%;
  }
}

table {
  border-collapse: separate;
  border-spacing: 0 0.5em;
}
</style>
